export default __webpack_public_path__ + "static/banner-digital-financial-management-is-safer-than-cash-c26354c970a20992422e1d6b65398d51.jpg";